import React from 'react';
import PropTypes from 'prop-types';
import SingleDataContainer from 'containers/Data/SingleDataContainer';
import utils from 'helpers/utils';
import { Link } from 'react-router-dom';
import { fetchAccountAccumulated } from 'store/actions/accounts/fetchAccounts';
import Chip from 'components/ui/chip/Chip';
import theme from 'theme/theme';

const linkStyle = {
    textDecoration: 'none',
    color: theme.palette.black,
};

class AccountField extends React.Component {
    render() {
        const {
            display,
            record,
            source,
            style,
        } = this.props;

        if (utils.isEmpty(record)) {
            return null;
        }

        return (
            <span style={ style }>
                <SingleDataContainer
                    action={ fetchAccountAccumulated }
                    id={ record[source] }
                    resource='accounts'
                >
                    { (renderProps) => {
                        const { data } = renderProps;

                        return (
                            <Chip style={ Object.assign({}, style, { cursor: 'pointer' }) }>
                                <Link to={ `/accounts/${ record[source] }/show` } style={ linkStyle }>
                                    { data[display] }
                                </Link>
                            </Chip>
                        );
                    }}
                </SingleDataContainer>
            </span>
        );
    }
}

AccountField.propTypes = {
    display: PropTypes.string.isRequired,
    record: PropTypes.object,
    source: PropTypes.string.isRequired,
    style: PropTypes.object,
};

export default AccountField;



// WEBPACK FOOTER //
// ./src/components/field/AccountField.js